
import Trading from '../../components/Layouts/Marketplace/Trading/Trading'
export default function TradingLanding() {
    return <Trading />
}
